import React from 'react';
import bn from "../../../utils/bemnames";
import {formatOdds, getOutLink} from '../../../utils/odds';
import {getOddsClassName} from '../../../utils/outright-odds';
import {_t} from '../../../utils/translations';
import {IOdds, IProvider, oddsFormats, OddsStatus} from '../../../utils/types';
import OddsTrackingLink from '../../OddsTrackingLink';

interface IProps {
  odds: IOdds | null;
  provider: IProvider;
  oddsFormat: oddsFormats;
  isMobile?: boolean;
  outLinkPath: string|undefined|null;
  widgetId: number;
  builderComponentId?: number;
  eventId?: number,
}

const bem = bn.create('outright-odds-button-with-arrow');

const OutrightOddsButtonWithArrow: React.FC<IProps> = ({
  odds,
  provider,
  oddsFormat,
  outLinkPath,
  widgetId,
  builderComponentId = undefined,
  isMobile = false,
  eventId = undefined,
}) => {

  return (
    <div className={`${bem.b()} ${isMobile ? bem.m('mobile') : ''}`}>
      <OddsTrackingLink
        target={'_blank'}
        rel={'noreferrer'}
        className={bem.e('out-link')}
        outLink={getOutLink(outLinkPath, provider.slug, widgetId, eventId, builderComponentId)}
        providerId={provider.id}
        widgetId={widgetId}
      >
        <span className={`${bem.e('arrow')} ${bem.e(`arrow--${getOddsClassName(odds)}`)}`}/>
        <div className={bem.e('odds')}>
          {odds ? ([OddsStatus.closed, OddsStatus.offline].includes(odds.status)
            ? <s>{formatOdds(odds.odds, oddsFormat)}</s>
            : <span>{formatOdds(odds.odds, oddsFormat)}</span>
          ) : <span> - </span>}
        </div>
        {!isMobile && (
          <div className={bem.e('blind')}>
            <span>{_t('Bet now')}</span>
          </div>
        )}
      </OddsTrackingLink>
    </div>
  )
}

export default OutrightOddsButtonWithArrow;
